import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpen, faSignOutAlt,faTachometerAlt,faInfoCircle, faSearch, faCogs, faSignInAlt, faHistory,faHome, faListAlt, faStar, faTasks, faBriefcase, faUsers, faBed, faBook  } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { Toast, ToastContainer } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from "../../Context/AuthContext";
import { BASE_URL } from "../../constants";

import {SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink, SidebarRoute, SideBtnWrap} from './SidebarElements'
export const Sidebar = ({isOpen, toggle }) => {
    const { user, setUser, logout } = useAuth(); 
    const [isLoggedIn, setIsLoggedIn] = useState(false);
      const [toastMessage, setToastMessage] = useState('');
       const [showToast, setShowToast] = useState(false);
     const [loading, setLoading] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const isHomePage = location.pathname === '/';
      useEffect(() => {
    
        // Check for token presence and user data on page load
        const token = localStorage.getItem('token');
        const savedUserData = localStorage.getItem('userData');
      
        // If token and user data are present, keep user logged in
        if (token && savedUserData) {
          setIsLoggedIn(true);
          setUser(JSON.parse(savedUserData));
        } else {
          // If token or user data is missing, make sure to log out
          setIsLoggedIn(false);
          setUser(null);
        }
      setLoading(false);
      }, [setUser]);
      
    const handleLogout = async () => {
        const userId = user?.id;
      
        try {
          await axios.post(`${BASE_URL}/users/logout`, { userId }, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
          });
      
          // Clear localStorage and state
          localStorage.removeItem('token');
          localStorage.removeItem('userData');
          setIsLoggedIn(false);
          setUser(null);
          logout();
      
          navigate('/'); 
      
             setToastMessage('Logout successful!');
        setShowToast(true);
        } catch (error) {
   
        }
      }; 
    return (
      <>
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                {isHomePage && (
                     <>
        <SidebarLink to="about" onClick={toggle}>
  <FontAwesomeIcon icon={faInfoCircle} className="me-2" /> About
</SidebarLink>
{/*<SidebarLink to="discover" onClick={toggle}>
  <FontAwesomeIcon icon={faSearch} className="me-2" /> Discover
</SidebarLink>

<SidebarLink to="services" onClick={toggle}>
  <FontAwesomeIcon icon={faCogs} className="me-2" /> Services
</SidebarLink>
*/}
</>
                )}
                 {loading ? (
                    <div className="text-center mb-3">
                    </div>
) : isLoggedIn && user ? (
         <>
                   
<SidebarRoute to="/profile" >
<FontAwesomeIcon icon={faUserCircle} className="me-2" /> My Profile
</SidebarRoute>
<SidebarRoute to="/chat" >
<FontAwesomeIcon  icon={faEnvelopeOpen} className="me-2" /> Messages
</SidebarRoute>
<>
      {/* Admin Route */}
      {user.isAdmin ? (
        <>
        <SidebarRoute to="/admin/dashboard">
          <FontAwesomeIcon icon={faTachometerAlt} className="me-2" />
          Dashboard
        </SidebarRoute>
            <SidebarRoute  to="/admin/users"><FontAwesomeIcon icon={faUsers} className="me-2" />Rooms</SidebarRoute>
            <SidebarRoute  to="/admin/rooms"><FontAwesomeIcon icon={faBed} className="me-2" />Users</SidebarRoute>
            <SidebarRoute  to="/admin/courses"><FontAwesomeIcon icon={faBook} className="me-2" />Manage Task</SidebarRoute>
            <SidebarRoute to="/admin/jobs"><FontAwesomeIcon icon={faBriefcase} className="me-2" />Availability</SidebarRoute>
            <SidebarRoute to="/admin/availability"><FontAwesomeIcon icon={faHistory} className="me-2" />Courses</SidebarRoute>
            <SidebarRoute to="/admin/manage"><FontAwesomeIcon icon={faTasks} className="me-2" />Jobs</SidebarRoute>
       
       </>
      ) : (
        <>
          {/* Refugee Route */}
          {user.isRefugee && (
            <SidebarRoute to="/dashboard">
              <FontAwesomeIcon icon={faTachometerAlt} className="me-2" />
             Dashboard
            </SidebarRoute>
          )}

          {/* State Route */}
          {user.isState && (
            <>
            <SidebarRoute to="/state/overview">
              <FontAwesomeIcon icon={faTachometerAlt} className="me-2" />
              Dashboard
            </SidebarRoute>
            <SidebarRoute to="/state/shelters"><FontAwesomeIcon icon={faHome} className="me-2" />Shelters</SidebarRoute>
             <SidebarRoute to="/state/admins"><FontAwesomeIcon icon={faUsers} className="me-2" />Admins</SidebarRoute>
              <SidebarRoute  to="/state/all-shelter-losses"><FontAwesomeIcon icon={faListAlt} className="me-2" />All Shelters Losses</SidebarRoute>
              <SidebarRoute  to="/state/recommandation"><FontAwesomeIcon icon={faStar} className="me-2" />Recommandation</SidebarRoute>

           
              </>           
         )}
         </>
       )}
     </>
<SideBtnWrap onClick={handleLogout}>
<FontAwesomeIcon icon={faSignOutAlt} className="text-danger me-2" /> Logout
</SideBtnWrap>
</>
     ): (
        <SidebarRoute to="/signin">
        <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
        Sign In
      </SidebarRoute>
      )}
                              
                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>
 
           <ToastContainer position="top-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            bg="success"
          >
            <Toast.Body className="text-white">{toastMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
</>
    )
}